import diff from 'deep-diff';
import shortid from 'shortid';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import sum from 'lodash/sum';
import isEqual from 'lodash/isEqual';
import difference from 'utils/difference';
import { put, fork, take, select, race } from 'redux-saga/effects';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../../../services/actions';
import * as actions from './actions';
import * as statusActions from '../status/actions';
import currentItem from './currentItem/saga';


function* updateItemsConfiguration() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.UPDATE_ITEMS_CONFIGURATION);
  if (success) {
    if (success.data.statusCode === 1) {
      yield put(actions.save.end());
      yield put(actions.invalidateServer.begin());
      yield put(statusActions.invalidateServer.begin());
        ttb.Notifications.ShowSaveSuccessMessage('Project Configuration', 'All changes has been saved');
    }
    else {
        ttb.Notifications.ShowErrorMessage('Project Configuration', success.data.statusMessage);
    }
} else {
  ttb.Notifications.ShowErrorMessage('Project Configuration', 'The changes have not been saved');
}
}

function* getItemsConfiguration() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.GET_ITEMS_CONFIGURATION);
  if (success) {
    const { items: itemsModel, simpleOptions, containerOptions, itemTypes, statuses: statusOptions, colors, statusBehaviours } = success.data;
    statusOptions.sort((a, b) => a.order - b.order);
    const itemOptions = itemsModel.map(value => {
      value.containerFor.sort();
      return {
        value: cloneDeep(value),
        $$localId: shortid.generate(),
        changes: 0,
      };
    });
    yield put(actions.init.end({ itemsModel, itemOptions, simpleOptions, containerOptions, statusOptions, colors, statusBehaviours, itemTypes }));
    yield put(actions.currentItem.setItem.begin(itemsModel[0].id));
  }
}

function* getActualItemsConfiguration() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.GET_ITEMS_CONFIGURATION);
  if (success) {
    const { items: itemsModel, simpleOptions, containerOptions, statuses: statusOptions } = success.data;
    statusOptions.sort((a, b) => a.order - b.order);
    const {
      itemsModel: previosItems,
      itemOptions: previosItemOptions,
      currentItem: selectedItem,
       } = yield select(state => state.configuration.project.editor.itemType);


    let itemOptions = itemsModel.map((x) => {
      const value = cloneDeep(x);
      const previosItemValue = find(previosItems, y => y.id === x.id);
      if (previosItemValue) {
        const previosItemOption = find(previosItemOptions, y => y.value.id === x.id);
        const changes = diff(previosItemValue, value);
        if (changes) {
          changes.forEach((change) => {
            diff.applyChange(previosItemOption.value, value, change);
          });
        }
        return cloneDeep(previosItemOption);
      }
      return {
        value,
        $$localId: shortid.generate(),
        changes: 0,
      };
    });
    previosItemOptions.forEach((item)=>{
      if(item.value.id < 0)
      {
        var savedItem = find(itemOptions, y => y.value.name === item.value.name)
        if(!savedItem)
        {
          itemOptions.push(item);
        }
      }
    })
    yield put(actions.invalidateServer.end({ itemsModel, itemOptions, statusOptions, simpleOptions, containerOptions }));
    yield put(actions.currentItem.setItem.begin(selectedItem.id));
    yield put(actions.invalidateServer.invalidate());
  }
}

function* checkValidation() {
  const { errors } = yield take(actions.currentItem.CHECK_VALIDATION.END);
  if (!errors) {
    const {
      projectId,
      currentItem: selectedItem,
       } = yield select(state => state.configuration.project.editor.itemType);
    yield put(serviceActions.api.configuration.project.updateItemsConfiguration.request({
      projectId,
      item: selectedItem.value,
    }));
    yield fork(updateItemsConfiguration);
  }
}

function* init() {
  while (true) {
    const { projectId } = yield take(actions.INIT.BEGIN);
    yield put(serviceActions.api.configuration.project.getItemsConfiguration.request({
      projectId,
    }));
    yield fork(getItemsConfiguration);
  }
}

function* invalidateStatus() {
  while (true) {
    yield take(actions.INVALIDATE_SERVER.BEGIN);
    const { projectId } = yield select(state => state.configuration.project.editor.itemType);
    if (projectId) {
      yield fork(getActualItemsConfiguration);
      yield put(serviceActions.api.configuration.project.getItemsConfiguration.request({
        projectId,
      }));
    }
  }
}

function* save() {
  while (true) {
    yield take(actions.SAVE.BEGIN);
    yield fork(checkValidation);
    yield put(actions.currentItem.checkValidation.begin());
  }
}

function* invalidate() {
  while (true) {
    yield race([
      take(actions.SAVE.END),
      take(actions.INVALIDATE_SERVER.INVALIDATE),
      take(actions.currentItem.SET_NAME),
      take(actions.currentItem.SET_ITEM_COLOR),
      take(actions.currentItem.SET_IS_ACTIVE),
      take(actions.currentItem.SET_CONTAINER_TYPE.END),
      take(actions.currentItem.SET_CONTAINER_FOR),
      take(actions.currentItem.statusFlow.SET_STATUS_ID),
      take(actions.currentItem.statusFlow.SET_COLOR),
      take(actions.currentItem.statusFlow.SET_STATUS_TYPE),
      take(actions.currentItem.statusFlow.SET_DEFAULT_STATUS),
      take(actions.currentItem.statusFlow.SET_COMPLETED_ON_SPRINT),
      take(actions.currentItem.statusFlow.SET_CALCULATE_SPENT_TIME),
      take(actions.currentItem.statusFlow.ADD_FLOW),
      take(actions.currentItem.statusFlow.ADD_COMPLETED),
      take(actions.currentItem.statusFlow.REMOVE),
      take(actions.currentItem.RESET_CHANGES.END),
      take(actions.currentItem.SET_REMOVED),
      take(actions.currentItem.SELECT_ITEMTYPE.END),
    ]);
    const {
      itemsModel,
      itemOptions: previosItems,
      currentItem: selectedItem,
       } = yield select(state => state.configuration.project.editor.itemType);
    
     const newItems = previosItems.map((x) => {
      const res = x.$$localId === selectedItem.$$localId && !isEqual(x.value, selectedItem.value)
        ? { ...selectedItem }
        : x;
      const itemValue = find(itemsModel, y => y.id === res.value.id);
      const changes = itemValue ? difference(res.value, itemValue) : 1;
      return res.changes === changes ? res : {
        ...res,
        changes,
      };
    });

    const itemOptions = isEqual(newItems, previosItems)
      ? previosItems
      : newItems;
    const allChanges = sum(itemOptions.map(x => x.changes));
    yield put(actions.invalidate({ itemOptions, changes: allChanges }));
    const newSelectedItem = find(itemOptions, x => x.$$localId === selectedItem.$$localId);
    if (newSelectedItem && newSelectedItem.changes !== selectedItem.changes) {
      yield put(actions.currentItem.invalidateChanges({ changes: newSelectedItem.changes }));
    }
    yield put(actions.currentItem.checkValidation.begin());
  }
}
function* remove()
{
  while (true) {
    const { localId } = yield take(actions.REMOVE.BEGIN);
    const { itemOptions } = yield select(state => state.configuration.project.editor.itemType);
    const newItemOptions = itemOptions.filter(x => x.$$localId !== localId);
    yield put(actions.remove.end({ itemOptions: newItemOptions }));
    yield put(actions.currentItem.setItem.begin(newItemOptions[newItemOptions.length - 1].id));
    yield put(actions.invalidateServer.invalidate());
   }
}

function* add() {
  while (true) {
    yield take(actions.ADD_ITEM.BEGIN);

    const { itemOptions } = yield select(state => state.configuration.project.editor.itemType);
    const { statusOptions } = yield select(state => state.configuration.project.editor.status);
    let activeItem = find(itemOptions, x => x.value.isActive)
    if(!activeItem)
    {
      activeItem = itemOptions[0];
    }
    const INITIAL_STATYS_TYPE = 1;
    const FINAL_STATYS_TYPE = 4;
    const itemToClone = cloneDeep(activeItem.value);
    let newId = -1;
    itemOptions.forEach((item) => {
      if(item.value.id <= newId)
      {
        newId = item.value.id - 1;
      } 
    });
    let itemStatuses = [];
    itemStatuses.push(find(itemToClone.statuses, x => x.type === INITIAL_STATYS_TYPE));
    itemToClone.statuses.forEach((status)=> {
      if(status.type === FINAL_STATYS_TYPE)
      {
        itemStatuses.push(status);
      }
    })
    itemOptions.push({
      $$localId: shortid.generate(),
      value: {
      containerFor: itemToClone.containerFor,
      containerType: itemToClone.containerType,
      isActive: true,
      name: 'New Item ('+(-newId)+')',
      type: itemToClone.type,
      id: newId,
      itemColor: 0,
      hasContainer: itemToClone.hasContainer,
      statuses: itemStatuses}
    });
    yield put(actions.addItem.end({ itemOptions }));
    yield put(actions.currentItem.setItem.begin(newId));
    yield put(actions.invalidateServer.invalidate());
  }
}


export default function* itemType() {
  yield fork(currentItem);
  yield fork(add);
  yield fork(init);
  yield fork(remove);
  yield fork(save);
  yield fork(invalidate);
  yield fork(invalidateStatus);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/saga.js